import React from "react";
import { styled } from "styled-components";
import mucoin from "../../styles/images/img_mucoin.png";
import musmile from "../../styles/images/ico_mu_smile.svg";
import { FlexBox } from "../../styles/Common";
import { replaceCommas } from "../hooks/basicFunc";
import { useSelector } from "react-redux";

const TopPointBanner = (props) => {
  const { mup } = props;
  const userInfo = useSelector((state) => state.user.userInfo);
  return (
    <BannerWrap>
      <BannerFlexBox>
        <img src={mucoin} alt="" />
        <Text>
          <h4>{replaceCommas(userInfo.mup)} Point</h4>
          <p>1P = 1 KRW</p>
        </Text>
      </BannerFlexBox>
    </BannerWrap>
  );
};

export default TopPointBanner;

const BannerWrap = styled.div`
  height: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.purple_bg_dark};
  img {
    width: 9rem;
    margin-right: 2.8rem;
  }
`;

const BannerFlexBox = styled(FlexBox)`
  justify-content: center;
  /* align-items: end; */
`;

const Text = styled.div`
  text-align: right;
  /* margin-top: 1.7rem; */
  span {
    color: ${({ theme }) => theme.color.pink};
    font-size: 1rem;
    font-weight: 700;
    line-height: 1rem; /* 100% */
    letter-spacing: -0.3px;
  }
  h4 {
    color: ${({ theme }) => theme.color.purple_dark};
    text-align: right;
    font-family: NanumSquareEB;
    font-size: 1.6rem;
    line-height: 1.6rem;
    display: flex;
    align-items: center;
    /* margin-top: 0.5rem; */
    &::before {
      display: block;
      content: "";
      width: 4.4631rem;
      height: 1.6rem;
      background: url(${musmile}) center center/cover no-repeat;
      margin-right: 1rem;
    }
  }
  p {
    color: ${({ theme }) => theme.color.purple_secondary};
    font-family: NanumSquareB;
    font-size: 1rem;
    line-height: 1rem;
    letter-spacing: -0.3px;
    /* margin-bottom: 0.6rem; */
    margin-top: 0.5rem;
  }
`;
